export default __webpack_public_path__ + "static/media/Oasis.b12171a2.png";